<script>
import { mapActions, mapGetters } from "vuex";

import stages from "~/src/service/stages";
import UploadFile from "../UploadFile.vue";
const onlyTextRegexp = /[(a-z)(A-Z)(')(`)( )]/;

export default {
  components: { UploadFile },
  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    isLoading: false,

    isValid: false,

    years: Array.from(
      { length: new Date().getFullYear() - 1980 },
      (value, index) => 1981 + index
    ).reverse(),

    onlyText(v) {
      return [...v].filter((x) => x?.match(onlyTextRegexp));
    },
  }),

  filters: {
    replace: function (st, rep, repWith) {
      const result = st.split(rep).join(repWith);
      return result;
    },
  },

  computed: {
    ...mapGetters("application", [
      "GET_APPLICATION",
      "GET_EDUCATION_FACULTYS",
      "GET_EDUCATION_TYPES",
      "GET_EDUCATION_LANGUAGES",
      "GET_SCHOOL_TYPES",
      "GET_COUNTRYS",
      "GET_REGIONS",
      "GET_CITYS",
    ]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    applicationMiddleNameModel: {
      get: (vm) => vm.application.middleName,
      set: function (newValue) {
        this.application.middleName = `${newValue || ""}`.replace("`", "'");
      },
    },

    applicationLastNameModel: {
      get: (vm) => vm.application.lastName,
      set: function (newValue) {
        this.application.lastName = `${newValue || ""}`.replace("'", "~");
      },
    },

    applicationFirstNameModel: {
      get: (vm) => vm.application.firstName,
      set: function (newValue) {
        this.application.firstName = `${newValue || ""}`.replace("`", "'");
      },
    },

    isReadonlyForm2() {
      if (this.application.canEditAccepted) {
        return false;
      } else {
        return this.isReadonly;
      }
    },
    isStaj: (vm) =>
      vm.application.educationFaculty.id == 4 &&
      vm.application.educationType.id == 3,
    isCert: (vm) => vm.application.foreignLanguageProficiency.id != 1,
    isOtherCert: (vm) => vm.application.foreignLanguageProficiency.id == 6,
    isHasPinflData: (vm) => vm.user.hasPinflData,
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },
    onNext() {
      this.isValid = true;
      if (this.$refs.form.validate()) {
        this.$nextTick(() => {
          const el = document.querySelector(".error--text");

          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            this.application.mobilePhone = this.user.phone;
            this.application.stage = stages.COURSE_OF_STUDY;

            this.onSend();
          }
        });
      } else {
        this.$store.dispatch("SET_SNACKBAR", {
          text: this.$t("fill_required"),
          color: "info",
        });
      }
    },

    ...mapActions("application", [
      "SET_APPLICATION",
      "SAVE_APPLICATION",
      "PART_SAVE_APPLICATION",
      "INIT_EDUCATION_FACULTYS",
      "INIT_EDUCATION_TYPES",
      "INIT_EDUCATION_LANGUAGES",
      "INIT_REGIONS",
      "INIT_CITYS",
    ]),

    onChangeApp() {
      this.$nextTick(() => {
        this.SET_APPLICATION(this.application);
      });
    },

    onChangeCountry() {
      const params = { countryId: this.application.country.id };
      this.isLoading = true;

      this.INIT_REGIONS(params).then(() => {
        this.isLoading = false;
      });

      this.application.region.id = null;
      this.application.city.id = null;

      this.onChangeApp();
    },

    onChangeRegion() {
      const params = { regionId: this.application.region.id };
      this.isLoading = true;

      this.INIT_CITYS(params).then(() => {
        this.isLoading = false;
      });

      this.application.city.id = null;

      this.onChangeApp();
    },

    onChangeEducationFaculty() {
      const params = { id: this.application.educationFaculty.id };
      this.isLoading = true;

      this.application.educationType.id = null;
      this.application.educationLanguage.id = null;
      this.application.additionalFaculty = [];

      this.INIT_EDUCATION_TYPES(params).then(() => {
        this.isLoading = false;
      });

      this.onChangeApp();
    },

    onChangeEducationType() {
      const params = {
        typeId: this.application.educationType.id,
        facultyId: this.application.educationFaculty.id,
      };

      this.isLoading = true;

      this.application.educationLanguage.id = null;
      this.application.additionalFaculty = [];

      this.INIT_EDUCATION_LANGUAGES(params).then(() => {
        this.isLoading = false;
      });

      this.onChangeApp();
    },

    onChangeEducationLanguage() {
      const id = this.application.educationLanguage.id;
      const langs = this.GET_EDUCATION_LANGUAGES;
      const lang = langs.find((x) => x.language.id == id);

      if (lang) {
        this.application.scienceComplex = lang.scienceComplex || {};

        this.onChangeApp();
      }
    },

    onSend() {
      this.isValid = true;
      this.$refs.form.validate();
      this.$refs.form1?.validate();
      this.$refs.form2?.validate();
      this.$nextTick(() => {
        const el = document.querySelector(".error--text");

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          this.SAVE_APPLICATION(this.application);
          this.reloadPage();
        }
      });
    },

    onChangeScore() {
      const str = this.application.dtmScore || "";
      if (!`${str}`.trim()) this.application.dtmAbiturientNumber = null;
      this.onChangeApp();
    },

    replaceChar(textStr) {
      return textStr.replaceAll("'", "'");
    },
  },
};
</script>

<template>
  <v-card color="white" elevation="0" rounded="0">
    <v-card-text class="pa-0">
      <v-form
        :disabled="isLoading || isReadonly"
        ref="form"
        lazy-validation
        onSubmit="return false;"
      >
        <div class="pa-3 pa-md-10">
          <v-row>
            <v-col cols="12" md="12">
              <div class="text-center">
                <img src="@/assets/icons/devider.svg" alt="" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <div class="accent--text bold--text">
                {{ $t("Name (as in Passport)") }} <span v-text="'*'" />
              </div>
              <v-text-field
                autofocus
                autocomplete="off"
                @blur="onChangeApp"
                v-model="applicationFirstNameModel"
                solo
                class="text-field"
                required
                :rules="[$rules.text]"
              />
              <div class="position-relative">
                <div
                  v-if="application.reviews.firstName && !isReadonly"
                  v-text="application.reviews.firstName"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="accent--text bold--text">
                {{ $t("Last name (as in passport)") }} <span v-text="'*'" />
              </div>
              <v-text-field
                autocomplete="off"
                @blur="onChangeApp"
                v-model="applicationLastNameModel"
                solo
                class="text-field"
                required
                :rules="[$rules.text]"
              />
              <div class="position-relative">
                <div
                  v-if="application.reviews.lastName && !isReadonly"
                  v-text="application.reviews.lastName"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="accent--text bold--text">
                {{ $t("Father's name (as in the passport)") }}
              </div>
              <v-text-field
                autocomplete="off"
                @blur="onChangeApp"
                v-model="applicationMiddleNameModel"
                solo
                class="text-field"
                required
                :rules="[$rules.text]"
              />
              <div class="position-relative">
                <div
                  v-if="application.reviews.middleName && !isReadonly"
                  v-text="application.reviews.middleName"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <div class="text-center">
                <img src="@/assets/icons/devider.svg" alt="" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <div class="accent--text bold--text">
                {{ $t("Passport series and number") }} <span v-text="'*'" />
              </div>
              <v-text-field
                autocomplete="off"
                @blur="onChangeApp"
                v-model="application.passportNumber"
                class="text-field"
                solo
                placeholder="AA1234567"
                required
                :rules="[$rules.passport]"
                v-inputmask="$masks.passport"
              />
              <div class="position-relative">
                <div
                  v-if="application.reviews.passportNumber && !isReadonly"
                  v-text="application.reviews.passportNumber"
                  class="red--text review-msg"
                />
              </div>
              <div class="accent--text bold--text">
                {{ $t("jshir") }} <span v-text="'*'" />
              </div>
              <v-text-field
                autocomplete="off"
                @blur="onChangeApp"
                v-model="application.jshir"
                class="text-field"
                placeholder="12345678912345"
                solo
                required
                :rules="[$rules.jshir12]"
                v-inputmask="$masks.numberLength12"
              />
              <div class="position-relative">
                <div
                  v-if="application.reviews.jshir && !isReadonly"
                  v-text="application.reviews.jshir"
                  class="red--text review-msg"
                />
              </div>
              <div class="accent--text bold--text">
                {{ $t("add phone number") }} <span v-text="'*'" />
              </div>
              <tel-input class="text-field" v-model="application.homePhone" />

              <div class="position-relative">
                <div
                  v-if="application.reviews.homePhone && !isReadonly"
                  v-text="application.reviews.homePhone"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div class="accent--text bold--text">
                {{ $t("Country") }} <span v-text="'*'" />
              </div>
              <v-select
                autocomplete="on"
                @change="onChangeCountry"
                v-model="application.country.id"
                class="text-field"
                solo
                required
                :rules="[$rules.required]"
                :items="GET_COUNTRYS"
                item-text="name"
                item-value="id"
                :loading="isLoading"
              />
              <div class="accent--text bold--text">
                {{ $t("Region") }} <span v-text="'*'" />
              </div>
              <v-select
                autocomplete="off"
                @change="onChangeRegion"
                v-model="application.region.id"
                class="text-field"
                solo
                required
                :rules="[$rules.required]"
                :items="GET_REGIONS"
                item-text="name"
                item-value="id"
              />
              <div class="accent--text bold--text">
                {{ $t("City / District") }} <span v-text="'*'" />
              </div>
              <v-select
                autocomplete="off"
                @change="onChangeApp"
                v-model="application.city.id"
                class="text-field"
                solo
                required
                :rules="[$rules.required]"
                :items="GET_CITYS"
                item-text="name"
                item-value="id"
                :loading="isLoading"
              />
            </v-col>
            <v-col cols="12" md="6">
              <img
                v-if="!isHasPinflData"
                class="align-content-center rasmcenter"
                src="../../assets/img/jshr_number.png"
                alt=""
              />

              <upload-File
                v-if="isHasPinflData"
                :readonly="true"
                required
                :isValid="isValid"
                param="photo"
              />
            </v-col>
          </v-row>
          <v-row v-if="isHasPinflData">
            <v-col cols="12" md="12">
              <div class="text-center">
                <img src="@/assets/icons/devider.svg" alt="" />
              </div>
            </v-col>
          </v-row>
          <v-row v-if="!isHasPinflData">
            <v-col cols="12" md="6">
              <div class="accent--text bold--text">
                {{ $t("Upload a copy of your passport") }} <span v-text="'*'" />
              </div>

              <div
                v-if="application.reviews.passportPhoto && !isReadonly"
                v-text="application.reviews.passportPhoto"
                class="red--text pb-2"
              />

              <upload-file
                :readonly="isReadonly"
                required
                :isValid="isValid"
                param="passportPhoto"
              />
            </v-col>
            <v-col cols="12" md="6">
              <div class="accent--text bold--text">
                {{ $t("Upload a copy of your passport back") }}
                <span v-text="'*'" />
              </div>

              <div
                v-if="application.reviews.passportBackPhoto && !isReadonly"
                v-text="application.reviews.passportBackPhoto"
                class="red--text pb-2"
              />

              <upload-file
                :readonly="isReadonly"
                required
                :isValid="isValid"
                param="passportBackPhoto"
              />
            </v-col>
          </v-row>
          <v-row v-if="!isHasPinflData">
            <v-col cols="12" md="12">
              <div class="text-center">
                <img src="@/assets/icons/devider.svg" alt="" />
              </div>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" md="6">
              <div class="accent--text bold--text">
                {{ $t("DTM result") }}
              </div>
              <v-text-field
                autocomplete="off"
                @blur="onChangeScore"
                v-model="application.dtmScore"
                class="text-field"
                solo
                clearable
                v-inputmask="$masks.number2"
              />

              <div class="position-relative">
                <div
                  v-if="application.reviews.dtmScore && !isReadonly"
                  v-text="application.reviews.dtmScore"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6" v-if="application.dtmScore">
              <div class="accent--text bold--text">
                {{ $t("Applicant dtm ID number") }}
                <span v-text="'*'" />
              </div>
              <v-text-field
                autocomplete="off"
                @blur="onChangeApp"
                v-model="application.dtmAbiturientNumber"
                class="text-field"
                placeholder="1234567"
                solo
                required
                :rules="[application.dtmScore ? $rules.dtmid : true]"
                v-inputmask="$masks.numberLength7"
              />

              <div class="position-relative">
                <div
                  v-if="application.reviews.dtmAbiturientNumber && !isReadonly"
                  v-text="application.reviews.dtmAbiturientNumber"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" md="12">
              <div class="text-center">
                <img src="@/assets/icons/devider.svg" alt="" />
              </div>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" md="6">
              <h3>
                Hurmatli Abiturinet, Ta'lim yo'nalishi, o'qish turi va tilini
                tanlang
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div class="accent--text bold--text">
                {{ $t("Choose a field of study") }} <span v-text="'*'" />
              </div>
              <v-autocomplete
                @change="onChangeEducationFaculty"
                :items="GET_EDUCATION_FACULTYS"
                v-model="application.educationFaculty.id"
                item-value="id"
                item-text="name"
                class="text-field"
                solo
                required
                :rules="[$rules.required]"
              />

              <div class="position-relative">
                <div
                  v-if="application.reviews.educationFaculty && !isReadonly"
                  v-text="application.reviews.educationFaculty"
                  class="red--text review-msg"
                />
              </div>
              <div class="accent--text bold--text">
                {{ $t("Choose the type of education") }} <span v-text="'*'" />
              </div>
              <v-select
                item-value="id"
                item-text="name"
                autocomplete="off"
                @change="onChangeEducationType"
                v-model="application.educationType.id"
                class="text-field"
                solo
                required
                :rules="[$rules.required]"
                :items="GET_EDUCATION_TYPES"
              />

              <div class="position-relative">
                <div
                  v-if="application.reviews.educationType && !isReadonly"
                  v-text="application.reviews.educationType"
                  class="red--text review-msg"
                />
              </div>

              <div class="accent--text bold--text">
                {{ $t("Choose the language of instruction") }}
                <span v-text="'*'" />
              </div>
              <v-select
                autocomplete="off"
                item-value="language.id"
                item-text="language.name"
                @change="onChangeEducationLanguage"
                :items="GET_EDUCATION_LANGUAGES"
                v-model="application.educationLanguage.id"
                class="text-field"
                solo
                required
                :rules="[$rules.required]"
              />
              <div class="position-relative">
                <div
                  v-if="application.reviews.educationLanguage && !isReadonly"
                  v-text="application.reviews.educationLanguage"
                  class="red--text review-msg"
                />
              </div>
            </v-col>
            <template v-if="isStaj">
              <v-col cols="12" md="6">
                <div class="accent--text bold--text">
                  {{ $t("staj_kiriting") }}
                  <span v-if="isCert" v-text="'*'" />
                </div>
                <div class="position-relative">
                  <div
                    v-if="application.reviews.stajYear && !isReadonly"
                    v-text="application.reviews.stajYear"
                    class="red--text review-msg"
                  />
                </div>
                <v-text-field
                  autocomplete="off"
                  @blur="onChangeApp"
                  v-model="application.stajYear"
                  class="text-field"
                  solo
                  :required="isStaj"
                  :disabled="!isStaj"
                  :rules="[isStaj ? $rules.required : true]"
                  v-inputmask="$masks.number"
                />

                <div class="accent--text bold--text">
                  {{ $t("staj_rasm") }}
                  <span v-if="isStaj" v-text="'*'" />
                </div>
                <div
                  v-if="application.reviews.stajPhoto && !isReadonly"
                  v-text="application.reviews.stajPhoto"
                  class="red--text review-msg"
                />

                <upload-file
                  :viewHeight="'60%'"
                  :readonly="isReadonly"
                  :required="isStaj"
                  :isValid="isValid"
                  param="stajPhoto"
                />
              </v-col>
            </template>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <div class="text-center">
                <img src="@/assets/icons/devider.svg" alt="" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <div class="d-flex pt-10">
                <v-spacer />
                <v-btn
                  @click="onNext"
                  color="accent"
                  elevation="0"
                  class="border-0"
                  :disabled="isReadonly && isReadonlyForm2"
                >
                  {{ $t("send_btn") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
